/**
 * 渐入向上动画配置
 * @param options 配置参数
 * @returns 动画变体配置
 */
export const fadeInUpVariants = ({ hiddenY = 100 }: { hiddenY?: number } = {}) => ({
  hidden: { opacity: 0, y: hiddenY },
  visible: (custom: number) => ({
    opacity: 1,
    y: 0,
    transition: {
      delay: custom * 0.2,
      duration: 0.8,
      ease: [0.22, 1, 0.36, 1] as const,
    },
  }),
});
